const recommendation_categoryRouter = [
  {
      path: "list-recommendation_category",
      name: "list",
      component: () => import("@/views/admin/recommendation_category"),
      default: true,
      meta: {
          model: "recommendation_category",
          // requiresAuth: true,
      },
  },
  {
      path: "list-recommendation_category/add",
      name: "add",
      component: () => import("@/views/admin/recommendation_category/function"),
      default: true,
      meta: {
          model: "recommendation_category",
          // requiresAuth: true,
      },
  },
  {
      path: "list-recommendation_category/edit/:id",
      name: "edit",
      component: () => import("@/views/admin/recommendation_category/function"),
      default: true,
      meta: {
          model: "recommendation_category",
          // requiresAuth: true,
      },
  },
];
export default recommendation_categoryRouter;